import { IDatasourceReportFn, IKeyValueHooks, IKeyValueSynchronous } from 'core-ts-types';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';
import { Metasource } from 'utility-ts-datasource';
import { PlanFeedbackTerm } from '../builders/plan_feedback_term_builder';

export interface IPlanFeebackTermsDatasource extends IDatasource<PlanFeedbackTerm> {}

angular.module('capability-ng-academic-planner').factory(
  'ngPlanFeebackTermsDatasource',
  () =>
    new Datasource<PlanFeedbackTerm>({
      builderType: PlanFeedbackTerm
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/datasources/plan_feedback_terms_datasource.ts